// @flow
import * as React from "react";
import type { InputField } from "types/input-field";

import SignatureInput from "./SignatureInput";

type Props = {
  inputField: InputField,
  fontSize: number,
};

function InitialsInput({ inputField, fontSize }: Props): React.Node {
  return (
    <SignatureInput initials fontSize={fontSize} inputField={inputField} />
  );
}

export default InitialsInput;
